import React from "react";
import { Card, Avatar, Button, Divider } from "antd";
import { Helmet } from "react-helmet";

const { Meta } = Card;

function CardComponent({ config, data }) {
  return (
    <>
      <Card style={config.cardConfig}>
        <Meta
          avatar={
            <div
              style={{
                flex: 1,
                justifyContent: "center",
                alignItems: "center",
                marginTop: "10px",
                marginLeft: "5px",
              }}
            >
              <i
                class={`fa ${config.headerIcon.icon}`}
                style={config.headerIcon}
              ></i>
            </div>
          }
          title={<h1 style={config.headerLegend}>Inventory Value</h1>}
          description={
            <>
              <div style={{ flex: 1, flexDirection: "row" }}>
                <h1 style={config.headerValue}>$130,568</h1>
                <div style={config.deltaText}>+127 since last week</div>
              </div>
            </>
          }
        />

        <div
          id={config.id}
          style={{
            width: "100%",
            height: config.cardConfig.chartHeight,
            padding: "5px",
            margin: "5px",
          }}
        ></div>
        <Helmet>
          <script>{`
          am4core.ready(function() {
let ${config.id} = am4core.create('${config.id}', ${config.type});
${config.id}.data=${JSON.stringify(data)}
${config.chartConfig}
});
        `}</script>
        </Helmet>
        <Divider style={config.seperatorLine} />
        <div>
          <div style={config.footerLegend}>Adjusted Inventory</div>
          <div style={config.footerValue}>$ 5151.51</div>
        </div>
      </Card>
    </>
  );
}

export default CardComponent;
